/* eslint-disable quote-props */
export default ($mdThemingProvider) => {
  'ngInject';

  const customPrimary = {
    '50': '#085796',
    '100': '#0965ae',
    '200': '#0b72c6',
    '300': '#0c80df',
    '400': '#128ef2',
    '500': '#2a99f4',
    '600': '#5ab1f6',
    '700': '#72bcf8',
    '800': '#8bc8f9',
    '900': '#a3d3fa',
    'A100': '#5ab1f6',
    'A200': '#42A5F5',
    'A400': '#2a99f4',
    'A700': '#bbdffb'
  };

  $mdThemingProvider.definePalette('customPrimary', customPrimary);

  const customAccent = {
    '50': '#7c6808',
    '100': '#947c0a',
    '200': '#ac900b',
    '300': '#c4a40d',
    '400': '#dbb80f',
    '500': '#efca14',
    '600': '#f3d444',
    '700': '#f4da5c',
    '800': '#f6df74',
    '900': '#f7e58c',
    'A100': '#f3d444',
    'A200': '#F1CF2C',
    'A400': '#efca14',
    'A700': '#f9eaa4'
  };

  $mdThemingProvider.definePalette('customAccent', customAccent);

  const customWarn = {
    '50': '#fcd3c3',
    '100': '#fac1ab',
    '200': '#f9b092',
    '300': '#f89e7a',
    '400': '#f68d62',
    '500': '#F57B4A',
    '600': '#f46932',
    '700': '#f2581a',
    '800': '#e64b0d',
    '900': '#ce430b',
    'A100': '#fde5db',
    'A200': '#fef6f3',
    'A400': '#ffffff',
    'A700': '#b53b0a'
  };

  $mdThemingProvider.definePalette('customWarn', customWarn);

  $mdThemingProvider.theme('default')
    .primaryPalette('customPrimary')
    .accentPalette('customAccent')
    .warnPalette('customWarn');

  /* Note that theming is diabled for performance reasons. The output CSS
  has been captured and copied to sass/material-theme.css. The resulting output
  will be loaded via ExtractTextPlugin in the production webpack build.
  */
  $mdThemingProvider.disableTheming();
};



// WEBPACK FOOTER //
// ./config/material-theme.js